<template>
  <div :id="id" class="contact">
    <div class="componata-container">
      <div class="grid-noGutter-equalHeight">
        <div class="col-6_md-7_sm-12">
          <div ref="wrapper">
            <FancyHeading class="contact__heading">
              <template v-slot:title><span v-html="content.title"></span></template>
            </FancyHeading>

            <div class="contact__options">
              <div class="contact__option">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                  <path
                    d="M14.137,17.7l.008,0a3.226,3.226,0,0,0,4.014-.441l.452-.451a1.076,1.076,0,0,0,0-1.521l-1.9-1.9a1.076,1.076,0,0,0-1.521,0h0a1.077,1.077,0,0,1-1.522,0l-3.042-3.043a1.076,1.076,0,0,1,0-1.521h0a1.076,1.076,0,0,0,0-1.521l-1.9-1.9A1.076,1.076,0,0,0,7.2,5.4l-.452.451a3.229,3.229,0,0,0-.44,4.015l0,.007A29.14,29.14,0,0,0,14.137,17.7Z"
                    fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                    stroke-width="1.5px"></path>
                  <path d="M21,18.764a11.251,11.251,0,1,0-9,4.5c4.418,0,6.446-2.136,5.215-5.344" fill="none"
                    stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5px"></path>
                </svg>

                <div>
                  <span>Telefonisch</span>
                  <br>
                  <a href="tel:034198992080">0341 9899 2080</a>
                </div>
              </div>

              <div class="contact__option">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                  <path d="M17.25,12A5.25,5.25,0,1,1,12,6.75,5.25,5.25,0,0,1,17.25,12Z" fill="none"
                    stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5px"></path>
                  <path d="M17.25,12v2.25a3,3,0,0,0,6,0V12a11.249,11.249,0,1,0-4.5,9" fill="none" stroke="currentColor"
                    stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5px"></path>
                </svg>

                <div>
                  <span>Per E-Mail</span>
                  <br>
                  <a :href="`mailto:${content.email}`">{{ content.email }}</a>
                </div>
              </div>
            </div>

            <p class="contact__description">Alternativ können Sie gerne unser Kontaktformular für Firmenkunden nutzen.
              Wir melden
              uns umgehend bei Ihnen.</p>

            <form v-if="!contactForm.isSubmitted" @submit.prevent="sendContactForm" class="form contact__form"
              data-context="contact-form">
              <div class="grid">
                <div class="col-2_lg-3_xs-6">
                  <div class="form__group">
                    <label :for="uid + '_contact_stuck'">Anzahl</label>
                    <input v-model="quantity" :id="uid + '_contact_stuck'" type="number" min="1" max="2000"
                      class="form__control" required>
                  </div>
                </div>

                <div class="col-3_lg-3_xs-6">
                  <div class="form__group">
                    <label :for="uid + '_contact_budget'">Budget</label>
                    <input v-model="contactForm.budget" :id="uid + '_contact_budget'" type="text" class="form__control"
                      placeholder="50 €" autocomplete="off">
                  </div>
                </div>
              </div>

              <span class="contact__divider"></span>

              <div class="grid">
                <div class="col-6_xs-12">
                  <div class="form__group">
                    <label :for="uid + '_contact_company'">Unternehmen</label>
                    <input v-model="contactForm.company" :id="uid + '_contact_company'" type="text"
                      class="form__control" required>
                  </div>
                </div>

                <div class="col-6_xs-12">
                  <div class="form__group">
                    <label :for="uid + '_contact_name'">Ansprechpartner:in</label>
                    <input v-model="contactForm.name" :id="uid + '_contact_name'" type="text" class="form__control"
                      required>
                  </div>
                </div>

                <div class="col-6_xs-12">
                  <div class="form__group">
                    <label :for="uid + '_contact_email'">E-Mail</label>
                    <input v-model="contactForm.email" :id="uid + '_contact_email'" type="email" class="form__control"
                      required>
                  </div>
                </div>

                <div class="col-6_xs-12">
                  <div class="form__group">
                    <label :for="uid + '_contact_phone'">Telefonnummer</label>
                    <input v-model="contactForm.phone" :id="uid + '_contact_phone'" type="tel" class="form__control"
                      required>
                  </div>
                </div>

                <div class="col-12">
                  <div class="form__group">
                    <label :for="uid + '_contact_comment'">Ihre Nachricht <span
                        class="u-text-muted">(Optional)</span></label>
                    <p class="u-text-muted">Teilen Sie uns gerne Ihre individuellen Anforderungen mit.</p>
                    <textarea v-model="contactForm.message" :id="uid + '_contact_comment'" class="form__control"
                      rows="4" placeholder="Geben Sie hier Ihre Nachricht oder Frage ein…"></textarea>
                  </div>
                </div>
              </div>

              <div class="contact__submission">
                <Button type="submit" appearance="primary" size="large" class="contact__btn">Senden <svg
                    xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                    <defs></defs>
                    <title>send-email-1</title>
                    <path
                      d="M2.05,10.387a1.487,1.487,0,0,1-.069-2.841L22.052,1A.751.751,0,0,1,23,1.943L16.459,22.024a1.486,1.486,0,0,1-2.841-.07l-2.246-9.331Z"
                      fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                      stroke-width="1.5px"></path>
                    <line x1="22.815" y1="1.18" x2="11.372" y2="12.623" fill="none" stroke="currentColor"
                      stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5px"></line>
                  </svg></Button>
              </div>
            </form>

            <div v-if="contactForm.isSubmitted && !contactForm.error" data-context="contact-success" class="contact__success">
              <p><i class="icon icon-check-circle contact__success-icon"></i></p>
              <h3>Vielen Dank, wir haben Ihre Nachricht erhalten!</h3>
              <p>Wir werden uns in Kürze mit Ihnen in Verbindung setzen.</p>
            </div>
            <div v-if="contactForm.isSubmitted && contactForm.error" data-context="contact-success" class="contact__success">
              <p><i class="icon icon-warning contact__warning-icon"></i></p>
              <h3>Fehler bei der Übertragung.</h3>
              <p>Bitten wenden Sie sich für Ihre Anfrage an den telefonischen Kontakt oder schreiben Sie uns eine Mail. Wir bitten die Unannehmlichkeiten zu entschuldigen</p>
            </div>
          </div>
        </div>

        <div class="col-6_md-5_sm-12">
          <div class="contact__media-wrapper">
            <img src="https://cdn.componata.de/wp-content/uploads/2023/04/box-green-opened.63180d75.png?width=957"
              width="957" height="618" alt="Componata's Präsente" class="contact__media">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// eslint-disable-next-line no-undef
/* global grecaptcha */
import axios from 'axios';
import { UiMixin } from '@/mixins/UiMixin';
import { helperMixin } from '@/mixins/HelperMixin';

import FancyHeading from '@/components/Pages/FancyHeading';
import Button from '@/components/Common/Button';

export default {
  name: 'Contact',
  mixins: [UiMixin, helperMixin],
  props: {
    id: {
      type: String,
      default: 'contact'
    },
    content: {
      type: Object
    }
  },
  components: {
    FancyHeading,
    Button
  },
  data() {
    return {
      uid: 0,
      quantity: 200,
      recaptchaToken: null,
      multipleShippingAddresses: false,
      contactForm: {
        isSubmitted: false,
        error: false,
        budget: '',
        company: '',
        name: '',
        email: '',
        phone: '',
        message: ''
      }
    };
  },
  methods: {
    loadRecaptchaScript() {
      if (!window.grecaptcha) {
        const script = document.createElement('script');
        script.src = `https://www.google.com/recaptcha/api.js?render=${process.env.VUE_APP_RECAPTCHA_SITE_KEY}`;
        script.async = true;
        script.defer = true;
        document.head.appendChild(script);
      }
    },
    async getRecaptchaToken(action) {
      if (!window.grecaptcha) {
        return null;
      }

      try {
        const token = await grecaptcha.execute(process.env.VUE_APP_RECAPTCHA_SITE_KEY, {
          action: action, // Beispiel: 'submit' oder 'login'
        });
        return token;
      } catch (error) {
        return null;
      }
    },
    async sendContactForm() {
      const token = await this.getRecaptchaToken('submit');
      if (token) {
        axios
          .post(process.env.VUE_APP_BASE_URL + '/verify-recaptcha.php', { token })
          .then((responseRe) => {
            if (responseRe.data.success) {
              const contactDetails = {
                quantity: this.quantity,
                multipleShippingAddresses: false,
                budget: this.contactForm.budget,
                company: this.contactForm.company,
                name: this.contactForm.name,
                email: this.contactForm.email,
                phone: this.contactForm.phone,
                message: this.contactForm.message
              };
              axios
                .post(process.env.VUE_APP_BASE_URL + '/wp-json/quiz/send', contactDetails)
                .then(response => {
                  if (response.data.status) {
                    this.keepWrapperHeight();
                    this.$store.commit('setGlobalLoading', true);
                    this.contactForm.error = false;
                    this.contactForm.isSubmitted = true;
                    this.gTag();
                    this.scrollTo('contact');
                    this.$store.commit('setGlobalLoading', false);
                  } else {
                    this.contactForm.error = false;
                  }
                })
                .catch(() => {
                  this.$store.commit('setGlobalLoading', false);
                  this.contactForm.error = false;
                });
            } else {
              // Validierung fehlgeschlagen
              this.scrollTo('contact');
              this.contactForm.error = true;
              this.contactForm.isSubmitted = true;
              this.$store.commit('setGlobalLoading', false);
            }
          })
          .catch((error) => {
            if (error) {
              this.scrollTo('contact');
              this.contactForm.error = true;
              this.contactForm.isSubmitted = true;
              this.$store.commit('setGlobalLoading', false);
            }
          });
      } else {
        this.scrollTo('contact');
        this.contactForm.error = true;
        this.contactForm.isSubmitted = true;
        this.$store.commit('setGlobalLoading', false);
      }
    },
    keepWrapperHeight() {
      this.$refs.wrapper.style.height = this.$refs.wrapper.scrollHeight + 'px';
    }
  },
  created() {
  },
  mounted() {
    this.loadRecaptchaScript();
  }
};
</script>

<style lang="scss" scoped>
/**
 * Contact
 *
 * @author juanpablob <m.juanpablob@gmail.com>
 * @desc Contact Section
 * @since 2022-07-08
**/

$component: 'contact';

.#{$component} {
  overflow: hidden;
  @include padding-bottom(map-get($spacers, 6) * 2);
  background: linear-gradient(to left, #fff, #FAFFF8);

  >.componata-container {
    background: url('https://cdn.componata.de/wp-content/uploads/2023/04/bgr-sizzlepng.png?width=1200') right top no-repeat;
    background-size: 70%;
  }

  &__heading {
    --from: #212B36;
    --to: #4C8761;
    --shadow: #ffffff01;

    @include margin-top(map-get($spacers, 6) * 2);
    text-align: left;
  }

  &__options {
    display: flex;
    flex-wrap: wrap;
    @include margin(map-get($spacers, 6) 0);
  }

  &__option {
    display: flex;
    align-items: center;

    &:not(:last-child) {
      @include margin-right(map-get($spacers, 6));
    }

    >svg {
      flex-shrink: 0;
      @include rfs(3rem, width);
      @include rfs(3rem, height);
      @include margin-right(map-get($spacers, 3));
      color: #4C8761;
    }

    >div {
      display: flex;
      flex-wrap: wrap;
      flex-direction: column;
      color: $ink-lighter;
      @include font-size(map-get($lp, 'font-size-lg'));
      font-weight: $font-weight-bold;

      br {
        display: none;
      }

      span {
        @include font-size(map-get($lp, 'font-size-sm'));
        font-weight: $font-weight-normal;
      }

      a {
        color: $ink-lighter;

        @include hover () {
          color: $ink-light;
        }

        &:active {
          color: $ink;
        }
      }
    }
  }

  &__description {
    margin: 0;
    @include font-size(map-get($lp, 'font-size-lg'));
    font-weight: $font-weight-light;
  }

  &__form {
    @include margin-top(map-get($spacers, 6));
  }

  &__btn {
    width: 100%;
  }

  &__success {
    @include margin-top(map-get($spacers, 6));
  }

  &__success-icon {
    color: $green;
    @include font-size(4rem);
  }

  &__warning-icon {
    color: $red;
    @include font-size(4rem);
  }

  &__media-wrapper {
    display: flex;
    align-items: flex-end;
  }

  &__media {
    @include imageRendering;
    display: flex;
    width: auto;
    max-width: unset;
    pointer-events: none;
    user-select: none;
  }

  /** RESPONSIVENESS **/

  // ——————————————————————————————
  // Max LG
  // ——————————————————————————————
  @media (max-width: map-get($lp, 'viewport-lg')) {}

  // ——————————————————————————————
  // Max MD
  // ——————————————————————————————
  @media (max-width: map-get($lp, 'viewport-md')) {
    &__heading {}
  }

  // ——————————————————————————————
  // Max SM
  // ——————————————————————————————
  @media (max-width: map-get($lp, 'viewport-sm')) {
    &__heading {
      width: 80%;
    }

    >.componata-container {
      background: none;
    }

    &__form {
      .grid>div[class^='col'] {
        @include padding-bottom(map-get($spacers, 4));
      }
    }

    &__media {
      display: none;
    }
  }

  // ——————————————————————————————
  // Max XS
  // ——————————————————————————————
  @media (max-width: map-get($lp, 'viewport-xs')) {
    &__heading {
      width: 90%;
    }

    &__options {
      @include margin-bottom(map-get($spacers, 3));
    }

    &__option {
      @include margin-bottom(map-get($spacers, 3));
    }
  }
}
</style>
